import { render, staticRenderFns } from "./vsDialogTabCustom.vue?vue&type=template&id=3bdc3828"
import script from "./vsDialogTabCustom.vue?vue&type=script&lang=js"
export * from "./vsDialogTabCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\site-teste\\flash-master\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bdc3828')) {
      api.createRecord('3bdc3828', component.options)
    } else {
      api.reload('3bdc3828', component.options)
    }
    module.hot.accept("./vsDialogTabCustom.vue?vue&type=template&id=3bdc3828", function () {
      api.rerender('3bdc3828', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Resources/js/src/components/vsDialogCustom/vsDialogTabCustom.vue"
export default component.exports